module.exports = __webpack_public_path__ + "static/media/sync.ddd0bde7.svg";